import { AssignPeopleForm } from 'components/forms/assign-people-form/assign-people-form';
import { useCallback } from 'react';
import { closeModal } from 'store/modals/modals.slice';

import { ASSIGN_PEOPLE_MODAL } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { Modal } from '../../template/modals/modal';

export const AssignPeopleModal = () => {
  const dispatch = useAppDispatch();

  const modal = useAppSelector((state) =>
    state.modals.find((modal) => modal.name === ASSIGN_PEOPLE_MODAL),
  );

  const handleClose = useCallback(() => {
    dispatch(closeModal({ name: ASSIGN_PEOPLE_MODAL }));
  }, [dispatch]);

  if (!modal || !modal.isOpen) {
    return null;
  }

  return (
    <Modal close={handleClose} forDivision>
      <AssignPeopleForm forEntity={modal.data} />
    </Modal>
  );
};
